import { useState } from 'react';
import { type FaqTopic } from '../components/hosted/FaqModal';

/**
 * Open state for the FAQ modal. Pass `open` to help links and spread `modal`
 * onto `<HostedFaqModal>`.
 */
export function useFaqModal() {
  const [topic, setTopic] = useState<FaqTopic | null>(null);

  return {
    open: setTopic,
    modal: {
      topic,
      onChangeTopic: setTopic,
      onClose: () => setTopic(null),
    },
  };
}
